import { createStore } from 'vuex'
import { getIndexData, getHelpList } from '../api/api'

export default createStore({
  state: {
    navHeaderList: [],
    phoneNumberList: [],
    articleCateList: [],
    navAd: ''
  },
  getters: {
  },
  mutations: {
    NAVLIST (state, [list, ad]) {
      state.navHeaderList = list
      state.navAd = ad
    },
    PHONELIST (state, [helpList, phoneList]) {
      state.articleCateList = helpList
      state.phoneNumberList = phoneList
    }
  },
  actions: {
    getHeaderList: async (context) => {
      try {
        const res: any = await getIndexData({
          tag: 'allBanner',
          banner_code: 'index',
          ds: 4
        })
        const data = res?.data || res
        const bannerindex = data?.bannerindex || []
        const bottomAd = data?.bottomAd || ''
        context.commit('NAVLIST', [bannerindex, bottomAd])
      } catch (e) {
        console.error('getHeaderList error:', e)
        context.commit('NAVLIST', [[], ''])
      }
    },
    getPhoneNumber: async (context) => {
      try {
        const res: any = await getHelpList({
          tag: 'helpList',
          ds: 4,
          articleId: 32,
          isHome: 1
        })
        const data = res?.data || res
        const articleCate = (data && Array.isArray(data.articleCate)) ? data.articleCate : []
        const phoneList = (articleCate[3] && articleCate[3].articleList) || (articleCate[0] && articleCate[0].articleList) || []
        context.commit('PHONELIST', [articleCate, phoneList])
      } catch (e) {
        console.error('getPhoneNumber error:', e)
        context.commit('PHONELIST', [[], []])
      }
    }
  },
  modules: {
  }
})

